import React from 'react';
import { Table } from 'reactstrap';
import { RecipientLeadSheetRecord } from '../../types/organizer';
import styles from '../../styles/archiveui.module.css';

interface RecipientPreviewTableProps {
  records: RecipientLeadSheetRecord[];
}

// Flatten a RecipientLeadSheetRecord for tabular display
const flattenRecord = (r: RecipientLeadSheetRecord): Record<string, string> => ({
  ...r.wildcardFields,
  Row: String(r.rowNumber),
  UniqueID: r.uniqueId,
  FirstName: r.firstName,
  LastName: r.lastName,
  DateOfBirth: r.dateOfBirth,
  DocumentType: r.documentType,
});

const RecipientPreviewTable = ({ records }: RecipientPreviewTableProps): JSX.Element => {
  if (records.length === 0) {
    return <div style={{ padding: '2em', textAlign: 'center', color: '#666' }}>No records to display</div>;
  }

  const flatRecords = records.map(flattenRecord);
  const columnSet = new Set<string>();
  flatRecords.forEach((row) => Object.keys(row).forEach((k) => columnSet.add(k)));
  const columns = Array.from(columnSet);

  return (
    <div style={{ marginTop: '1em' }}>
      <div style={{ marginBottom: '1em', fontWeight: 500 }}>{records.length} records loaded</div>
      <div style={{ overflowX: 'auto' }}>
        <Table striped hover size="sm" responsive>
          <thead className={styles.tableHeader}>
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {flatRecords.map((row, i) => (
              <tr key={records[i].rowNumber}>
                {columns.map((col) => (
                  <td key={col}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default RecipientPreviewTable;
